import { Component, OnInit, ViewChild } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay, map } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.css'],
  providers: [ToolbarService, ExcelExportService]
})
export class UsersListComponent implements OnInit {

  job_table: any;
  result: any;
  client_name: any;
  persons: any;
  job_table2: any;
  client_name_value: any;
 responseDelay = 2000;
  clients: any;
  clientLocalRecord: any;
  job_types: any;
  subjects: any;
  agents_assigned: any;
  staffList: any;
  items: Object[];
  data_subjects2: any;
  initialPage: PageSettingsModel;

  jobTypesLocalRecord: any;
  changeObject: any;

  subjectLocalRecord: any;

  createdAt: any;
  nextDateLocalRecord: any;

  agentsAssignedLocalRecord: any;
  allocated_agents_list: any;

  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  job_table3: any;
  brand_types: any;
  btLocalRecord: any;
  users: any;
  userLocalRecord: any;
  brands: any;
  user_levels: any;
  ulLocalRecord: any;
  bLocalRecord: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  sessionUserLevel: any;
  currentUserVAR: any;
  sessionUserFullName: string;
  sessionUserFirstName: any;


  constructor(
    private http: HttpClient, private router: Router, route: ActivatedRoute,private _demoService: DemoService,
    public datepipe: DatePipe, public gfunc: GlobalFunctionsService
  ) { 


// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;


  }

  ngOnInit() {

   // this.mapJobTableLive(); // load the table data
  

   this.getUsers(); // load the grid
    this.toolbarOptions = ['ExcelExport', 'Search'];
    this.initialPage = { pageSize:5 };
    this.filterOptions = {
      type: 'Menu'
   };
   this.groupOptions = { columns: ['brand_id'] }; // sets auto grouping for the grid
   this.formatOptions= {type:'date', format:'dd/MM/yyyy'};
  }



// New way of rendering table data
mapJobTableLive() {

 this.getBrands();
 this.getUserLevels();

  this.http.get<any>(this.gfunc.apiURL + 'api/users')
 .pipe(map(data => {
  // do your transformations
  this.job_table2 = data;

  this.job_table2.forEach(element => {


this.ulLocalRecord = this.user_levels.filter(c => c.level === element.access_level);
this.changeObject = Object.assign(this.ulLocalRecord);
if (this.changeObject[0] != null) {
 element.access_level  = this.changeObject[0].name;
}
 

this.bLocalRecord = this.brands.filter(c => c.brand_id === element.brand_id);
this.changeObject = Object.assign(this.bLocalRecord);
let recordCount = this.changeObject.length;
element.brand_id  = this.changeObject[0].name;

if (element.is_active != 1) {
  element.is_active = 'No';
}else{
  element.is_active = 'Yes';
}


if (element.is_primary_contact == 1) {
  element.is_primary_contact = 'Yes';
}else{
  element.is_primary_contact = 'No';
}


}); // end for each of all


return this.job_table3;
})
 ) // end pipe
  .subscribe(results => this.job_table3 = results
  );

}


toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

refreshGrid(){ // refresh the databutton
  this.mapJobTableLive();
  this.grid.refresh();
};


getBrands() {
  this._demoService.getBrands().subscribe(
    data => { this.brands = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getBrandBrandTypes(){
  this._demoService.getBrandBrandTypes().subscribe(
    data => { this.brand_types = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getUsers() {
  this._demoService.getUsersTableData().subscribe(
    data => { this.users = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}



getUserLevels() {
  this._demoService.getUserLevels().subscribe(
    data => { this.user_levels = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


userView(user_id) {
  this.router.navigate(['/admin/brands/users/view/' + user_id + '']);
}

userEdit(user_id) {
  this.router.navigate(['/admin/brands/users/edit/' + user_id + '']);
}



}
